"use client";
import Link from "@workspace/casino_pages/legacyLayer/client/components/Link";
import ControlsClose from "@workspace/casino_pages/legacyLayer/external/icons/ControlsClose";
import {
  Alert,
  AlertAction,
  AlertDescription,
  AlertTitle,
  Button,
  LinkIcon,
  ShieldIcon,
  TypographyText,
} from "@workspace/frontend-ui";
import { useEffect, useRef, useState } from "react";
import licenseUpdate from "@/actions/licenseUpdate";

type Props = {
  translations?: Record<string, string>;
  termsPdfUrl?: string;
};

export default function SnackbarTerms({ translations, termsPdfUrl }: Props) {
  const [dismissed, setDismissed] = useState(false);
  const acknowledged = useRef(false);
  const t = (key: string, fallback: string) => translations?.[key] ?? fallback;

  useEffect(() => {
    if (acknowledged.current) return;
    acknowledged.current = true;
    licenseUpdate({ intent: "ACKNOWLEDGE" }).catch(() => {});
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
  };

  if (dismissed) return null;

  return (
    <div className="fixed md:max-w-[360px] bottom-6 ltr:right-4 rtl:left-4 z-[999]">
      <Alert className="flex gap-x-3 bg-secondary shadow-xl border-none text-foreground pr-0">
        <div className="text-primary h-fit! bg-primary/20 p-1.5 rounded-md">
          <ShieldIcon size={16} />
        </div>
        <AlertDescription className="flex flex-col rtl:pl-[24px] ltr:pr-[24px]">
          <TypographyText
            as="p"
            className="font-normal m-0! p-0! text-foreground w-full text-sm"
          >
            {t(
              "terms.anjouan.mobile.posttitle",
              "Bitcasino.io now operates under an Anjouan licence. Your balance, open bets and bonuses are exactly where you left them.",
            )}
          </TypographyText>
          {termsPdfUrl && (
            <Button
              asChild
              variant="unstyled"
              className="text-primary hover:text-primary/80 justify-start! pl-0! "
            >
              <Link href={termsPdfUrl} target="_blank">
                <TypographyText variant="small" className="m-0! font-semibold">
                  {t("terms.anjouan.cta.link_text", "Read the updated Terms")}
                </TypographyText>
                <LinkIcon />
              </Link>
            </Button>
          )}
        </AlertDescription>
        <AlertAction>
          <Button
            variant="ghost"
            className="text-foreground"
            onClick={handleDismiss}
          >
            <ControlsClose fontSize={16} />
          </Button>
        </AlertAction>
      </Alert>
    </div>
  );
}
